import { Component } from '@angular/core';
import { PageModule } from 'gain-lib/page/page.module';

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
  imports: [PageModule],
})
export class NotFoundPageComponent {}
